import type { IStep } from "../types/steps.types";
import type { IUpdateConfigState } from "../types/store-states.types";

class Step implements IStep {
  name: string;
  title: string;
  view: boolean = true;
  skip: boolean = false;

  constructor(fields: IStep) {
    this.name = fields.name;
    this.title = fields.title;
    if (typeof fields.view !== 'undefined') {
      this.view = fields.view
    }
    if (typeof fields.skip !== 'undefined') {
      this.skip = fields.skip;
    }
  }
}

export default class StepsCollection {
  steps: Step[];

  constructor(steps: IUpdateConfigState['steps']) {
    if (!steps) throw new Error('Steps is not defined on config');
    this.steps = steps.map((fields) => new Step(fields));
  }

  get all() {
    return this.steps;
  }

  get firstView() {
    const firstViewStep = this.steps.find((step) => !step.skip && step.view);
    if (!firstViewStep) {
      throw new Error('No step to show to user');
    }
    return firstViewStep; 
  }
}